var _defs, _polygon, _polygon2, _g, _g2, _polygon3, _polygon4, _path, _path2, _polygon5, _polygon6, _polygon7, _polygon8, _polyline, _polyline2, _polyline3, _line, _polyline4, _polyline5, _polyline6, _path3, _line2, _line3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTremplinHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 323.17 323.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:none;}.cls-2{fill:#c00c69;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#f7d842;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#3d65ae;}.cls-7{fill:#025c3d;}.cls-8{stroke:#010101;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.64px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "261.29 129.39 261.29 207.72 232.24 184.13 203.53 160.8 173.63 176.9 173.63 211.27 173.63 318.25 206.97 300.15 206.97 229.8 206.97 221.42 264.9 268.84 294.87 252.54 294.87 111.19 261.29 129.39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.3 179.32 69.24 194.52 69.24 306.54 102.82 319 102.82 206.98 143.76 222.17 143.76 176.9 28.3 134.06 28.3 179.32"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "232.24 184.13 261.29 207.72 261.29 129.39 294.87 111.18 294.87 252.54 264.9 268.84 206.98 221.42 206.98 229.8 206.98 300.15 173.63 318.25 173.63 211.27 173.63 176.9 203.53 160.8 232.24 184.13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.76 176.9 143.76 222.17 102.82 206.98 102.82 319 69.24 306.54 69.24 194.52 28.3 179.32 28.3 134.06 143.76 176.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 321.28,
    r: 3.83
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 44.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 56.93,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 68.94,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 80.96,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 92.98,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 104.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 117.01,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 129.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 141.04,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 153.05,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 165.07,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 177.09,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 189.1,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 201.12,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 213.13,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 225.15,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 237.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 249.18,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 261.2,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 273.21,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 285.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 297.24,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.64,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.69,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.73,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.78,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.82,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.86,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.91,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.95,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.99,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.04,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.08,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.17,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.21,
    cy: 309.26,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -0.38,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.66,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.7,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.75,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.79,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.84,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.88,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.92,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.01,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.05,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.1,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.14,
    cy: 321.28,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.18,
    cy: 321.28,
    r: 3.83
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.86 111.19 261.28 129.4 261.28 207.73 232.24 184.14 231.41 183.48 231.41 118.29 264.99 100.09 294.86 111.19"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.89 268.85 235.03 257.74 206.97 234.77 206.97 229.81 206.97 221.43 264.89 268.85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M252.11,37.66V95.32l-90.52,49.06C252.11,95.32,252.11,37.66,252.11,37.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.11,37.66s0,57.66-90.52,106.72L71.33,110.87C161.89,61.81,161.89,4.18,161.89,4.18Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "203.52 160.81 173.62 176.91 173.62 211.28 173.62 318.26 143.75 307.16 143.75 222.16 143.75 176.91 28.29 134.06 58.19 117.96 161.59 156.34 173.65 149.7 203.52 160.81"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "132.71 218.08 132.71 302.89 102.81 318.99 102.81 206.97 132.71 218.08"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "231.41 183.48 232.24 184.14 261.28 207.73 261.28 129.4 294.86 111.19 294.86 252.55 264.89 268.85 206.97 221.43 206.97 229.81 206.97 234.77 206.97 300.16 173.62 318.26 173.62 211.28 173.62 176.91 203.52 160.81 231.41 183.48"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "143.75 176.91 143.75 222.16 132.71 218.08 102.81 206.97 102.81 318.99 69.23 306.53 69.23 194.52 28.29 179.31 28.29 134.06 143.75 176.91"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "173.62 318.26 143.75 307.16 143.75 222.16"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "294.86 111.19 264.99 100.09 231.41 118.29"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "203.52 160.81 173.65 149.7 161.59 156.34 58.19 117.96 28.29 134.06"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 235.03,
    y1: 257.74,
    x2: 206.97,
    y2: 234.77
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "102.81 318.99 132.71 302.89 132.71 218.08"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "231.41 118.29 231.41 183.48 231.41 184.14"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "71.33 110.87 161.59 144.38 252.11 95.32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.59,144.38c90.52-49.06,90.52-106.72,90.52-106.72V95.32"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 161.89,
    y1: 4.18,
    x2: 252.11,
    y2: 37.66
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 264.9,
    y1: 268.85,
    x2: 235.03,
    y2: 257.74
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M71.33,110.87C161.89,61.81,161.89,4.18,161.89,4.18"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTremplinHeader);
export default __webpack_public_path__ + "static/media/logo-tremplin-header.775d718b.svg";
export { ForwardRef as ReactComponent };